import axios from 'axios';
//import { Message } from 'element-ui';
import { Dialog } from 'vant';
import qs from 'qs'


axios.defaults.timeout = 20000;
axios.defaults.baseURL ='https://metaser.cn';
const service = axios.create({
  post: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': window.sessionStorage.getItem('token'),
        // 'Content-Type': 'application/json'
  }, // end post
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 200000, // request timeout
  transformRequest: [ data => qs.stringify(data) ]
  // transformRequest: [ data => qs.stringify(data) ]
})


//http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.headers = {
        'Content-Type': 'application/json',
        //'Authorization': 'Token ' + window.sessionStorage.getItem('token'),
        'Authorization': window.sessionStorage.getItem('token'),
      //'Content-Type':'application/x-www-form-urlencoded'
    }
      console.log(config);
    if(config.url == 'api/divination/file/uploadFile'){
      config.headers['Content-Type'] = 'multipart/form-data';
    }else{
      config.data = JSON.stringify(config.data);
    }
    // if(token){
    //   config.params = {'token':token}
    // }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    //  console.log(response);
    //if(response.headers.authorization) {
    //  window.sessionStorage.setItem('token',response.headers.authorization)
    //}

    if(response.data.errCode ==2){
      router.push({
        path:"/login",
        querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      })
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url,data){
   return new Promise((resolve,reject) => {
     axios.post(url,data)
          .then(response => {
            resolve(response.data);
          },err => {
            Dialog.alert({
              title: '提示',
              message: '网络错误！'
            }).then(() => {
              // on close
              //this.$router.push({path:'/login'})
            });
            reject(err)
          })
   })
 }

export function postForm(url, params){
  return service.post(url, params,{
    withCredentials: true,
    transformRequest: function (data) {
      // 对 data 进行任意转换处理
      return qs.stringify(data);
    },
    headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': window.sessionStorage.getItem('token'),
          // 'content-type': 'multipart/form-data;'
    }
  })
}


export function postUp(url, formData){
    console.log(formData);
    return new Promise((resolve,reject) => {
      axios.post(url,formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': window.sessionStorage.getItem('token'),
          }
      })
      .then(response => {
          console.log(response)
        resolve(response.data);
      },err => {
        reject(err)
      })
})


  //return service.post(url, params,{
  //  withCredentials: true,
  //  headers: {
  //        'Content-Type': 'uploadPicture',
  //        'Authorization': window.sessionStorage.getItem('token'),
  //        // 'content-type': 'multipart/form-data;'
  //  }
  //})
}




 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}
